/** The app version (package.json), injected at build time; 'dev' where the build does not inject it (unit tests). */
export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'dev';
